import messages from '../../../locale/messages'
import { inputDescLimit } from '../../../helpers/FieldRestriction';

const validate = values => {

  const errors = {}

  if (!values.reason) {
    errors.reason = messages.reasonRequired;
  } else if (values.reason.trim() == "") {
    errors.reason = messages.reasonRequired
  } else if (values.reason.length > inputDescLimit) {
      errors.reason = messages.inputDescLimitError
  }

  return errors
}

export default validate
